import React from 'react';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import { isCoordenadorOuApoioSecretarial } from '../../security/AuthorizedFunction';

import { Line } from 'react-chartjs-2';

const SERIES = [
    { key: 'recebidas', label: 'Recebidas', color: '#6a1b9a' },
    { key: 'digitalizadas', label: 'Digitalizadas', color: '#283593' },
    { key: 'cortadas', label: 'Cortadas', color: '#0277bd' },
    { key: 'leitura', label: 'Leitura de Marcações Realizada', color: '#00838f' },
    { key: 'digitadas', label: 'Digitadas', color: '#2e7d32' },
];

const SERIES_COORD = [
    { key: 'recebidas', label: 'Recebidas', color: '#6a1b9a' },
    { key: 'digitalizadas', label: 'Digitalizadas', color: '#283593' },
    { key: 'leitura', label: 'Leitura de Marcações Realizada', color: '#00838f' },
    { key: 'digitadas', label: 'Digitadas', color: '#2e7d32' },
];

export const Evolucao = ({ evolucao }) => {
    const dados = evolucao ?? [];

    const series = isCoordenadorOuApoioSecretarial() ? SERIES_COORD : SERIES;

    return (
        <Grid item xs={12} lg={6}>
            <Card style={{ height: '100%' }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>Evolução Diária</Typography>

                    { dados.length === 0 ?
                        <Typography variant="body2" color="textSecondary">Sem dados para exibir.</Typography>
                    :
                        <div style={{ height: 320 }}>
                            <Line
                                data={{
                                    labels: dados.map(d => d.dataFormatada),
                                    datasets: series.map(s => ({
                                        label: s.label,
                                        data: dados.map(d => d[s.key]),
                                        borderColor: s.color,
                                        backgroundColor: s.color,
                                        borderWidth: 2,
                                        tension: 0.3,
                                        pointRadius: 2,
                                    })),
                                }}
                                options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: { position: 'top' },
                                    },
                                    scales: {
                                        y: { beginAtZero: true, ticks: { precision: 0 } },
                                    },
                                }}
                            />
                        </div>
                    }
                </CardContent>
            </Card>
        </Grid>
    );
}

export default Evolucao;
